import { useSyncExternalStore } from "react";

/** Встроенные тексты UI-kit (ru по умолчанию). Приложение подменяет их через configureUiLocale при смене языка. */
export const UI_TEXT_RU = {
  ok: "Понятно",
  confirm: "Подтвердить",
  cancel: "Отмена",
  delete: "Удалить",
  actionFailed: "Не удалось выполнить действие",
  /** {text} — текст, который нужно ввести. Разделено на части вокруг выделенного значения. */
  typeToConfirmBefore: "Введите",
  typeToConfirmAfter: "для подтверждения",
  dialog: "Диалог",
  close: "Закрыть",
  clear: "Очистить",
  showPassword: "Показать пароль",
  hidePassword: "Скрыть пароль",
  search: "Поиск…",
  select: "Выберите…",
  nothingFound: "Ничего не найдено",
  loadError: "Ошибка загрузки. Попробуйте ещё раз.",
  create: (q: string) => `Создать «${q}»`,
  increase: "Увеличить",
  decrease: "Уменьшить",
  loading: "Загрузка",
  actions: "Действия",
  pages: "Страницы",
  pageRange: (from: number, to: number, total: number) => `${from}–${to} из ${total}`,
  prevPage: "Предыдущая страница",
  nextPage: "Следующая страница",
  selectAll: "Выбрать все",
  selectRow: "Выбрать",
  selectedCount: (n: number) => `Выбрано: ${n}`,
  clearSelection: "Снять выбор",
  grams: "г",
  kilograms: "кг",
  weight: "Вес",
  perKg: "за 1 кг",
};
export type UiText = typeof UI_TEXT_RU;

type UiLocale = { text: UiText; numberLocale: string; currencySymbols: Record<string, string> };

let state: UiLocale = {
  text: UI_TEXT_RU,
  numberLocale: "ru-RU",
  currencySymbols: { KGS: "сом", KZT: "₸", UZS: "сум", RUB: "₽", TJS: "сомони", USD: "$", EUR: "€" },
};
const listeners = new Set<() => void>();

export function configureUiLocale(patch: { text?: Partial<UiText>; numberLocale?: string; currencySymbols?: Record<string, string> }) {
  state = {
    text: { ...state.text, ...patch.text },
    numberLocale: patch.numberLocale ?? state.numberLocale,
    currencySymbols: { ...state.currencySymbols, ...patch.currencySymbols },
  };
  listeners.forEach((l) => l());
}

export const getUiLocale = () => state;

const subscribe = (cb: () => void) => {
  listeners.add(cb);
  return () => void listeners.delete(cb);
};

export const useUiText = () => useSyncExternalStore(subscribe, () => state.text, () => state.text);
